__turbopack_context__.v({
  "SArticle": "L45qPG_SArticle",
  "SPlaySvg": "L45qPG_SPlaySvg",
  "ThemeDk": "L45qPG_ThemeDk",
});
